import React from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import EditableText from './EditableText';

const SchmelzplanungText: React.FC = () => {

    const { language } = React.useContext(LanguageContext);
    const navigate = useNavigate();
    return (
        <div>
            {language === 'en' ?
               <><div className='text-grips fs-4 fs-md-3 fs-lg-2' id='167'>
               <EditableText id='167'  />
               <br />
            </div>
            <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='168'><EditableText id='168'  /></div>
            <br />
            <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='169'><EditableText id='169'  /></div>
            <br />
            <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='170'><EditableText id='170'  /></div>
            <br />
           <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='171'><EditableText id='171'  /></div>
            <br></br>
            <br></br>
            <button type="button" className="btn btn-outline-danger btn-lg" onClick={() => navigate("/merkmale")}>Back to Overview</button>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            </>
                :
                <><div className='text-grips fs-4 fs-md-3 fs-lg-2' id='172'>
               <EditableText id='172'  />
               <br />
            </div>
            <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='173'><EditableText id='173'  /></div>
            <br />
            <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='174'><EditableText id='174'  /></div>
            <br />
            <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='175'><EditableText id='175'  /></div>
            <br />
           <div className='text-grips fs-4 fs-md-3 fs-lg-2' id='176'><EditableText id='176'  /></div>
            <br></br>
            <br></br>
            <button type="button" className="btn btn-outline-danger btn-lg" onClick={() => navigate("/merkmale")}>Zurück zur Übersicht</button>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            </>
            }
        </div>
    );
}

export default SchmelzplanungText;